const pens = {
  penOrangeThick: {
    id: 'penOrangeThick',
    title: 'Stroke',
    subtitle: 'UF Orange, Thick',
    type: 'PEN',
    size: 'THICK',
    colorHex: '#EE4127',
  },
  penOrangeThin: {
    id: 'penOrangeThin',
    title: 'Stroke',
    subtitle: 'UF Orange, Thin',
    type: 'PEN',
    size: 'THIN',
    colorHex: '#EE4127',
  },
  penBlueThick: {
    id: 'penBlueThick',
    title: 'Stroke',
    subtitle: 'UF Blue, Thick',
    type: 'PEN',
    size: 'THICK',
    colorHex: '#007df9',
  },
  penBlueThin: {
    id: 'penBlueThin',
    title: 'Stroke',
    subtitle: 'UF Blue, Thin',
    type: 'PEN',
    size: 'THIN',
    colorHex: '#007df9',
  },
  penBlackThick: {
    id: 'penBlackThick',
    title: 'Stroke',
    subtitle: 'UF Black, Thick',
    type: 'PEN',
    size: 'THICK',
    colorHex: '#000',
  },
  penBlackThin: {
    id: 'penBlackThin',
    title: 'Stroke',
    subtitle: 'UF Black, Thin',
    type: 'PEN',
    size: 'THIN',
    colorHex: '#000',
  },
};

export default pens;
